module.exports = __webpack_public_path__ + "31127365f33c97604b9782c1826e6d15.MP3";